export default __webpack_public_path__ + "static/media/Spotify3.4f2f5945.PNG";